import { IconButton } from "@circleco/compass/components/IconButton";
import { DragHandle } from "@circleco/compass/components/SortableList";
import { useCommunitySwitcherContext } from "../context/CommunitySwitcherContext";
import { cn } from "../helpers/cn";

export interface CommunitiesModalLinkSortableDragHandleProps {
  readonly isDragDisabled: boolean;
}

export const CommunitiesModalLinkSortableDragHandle = ({
  isDragDisabled,
}: CommunitiesModalLinkSortableDragHandleProps) => {
  const { t } = useCommunitySwitcherContext();
  const ariaLabel = t("community_switcher_drag_handle");

  const button = (
    <IconButton
      aria-label={ariaLabel}
      className={cn({
        "cursor-grab": !isDragDisabled,
        "cursor-not-allowed": isDragDisabled,
      })}
      disabled={isDragDisabled}
      icon="drag"
      size="sm"
      variant="ghost"
    />
  );

  if (isDragDisabled) {
    return button;
  }

  return (
    <DragHandle
      aria-label={ariaLabel}
      className="inline-flex shrink-0 cursor-grab"
    >
      {button}
    </DragHandle>
  );
};
